<style lang="scss">
  @use "../../../../assets/css/_colors.scss" as *;
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  .video-preview-content {
    max-width: 800px;
    width: 100%;
    padding: 1.5rem 1.5rem 0rem 1.5rem;

    .video-modal-header {
      display: flex;
      justify-content: space-between;
      align-items: start;
      margin-bottom: 1rem;

      .title-and-duration {
        h2 {
          color: $soft-black;
          font-size: 1.1rem;
          margin: 0;
          margin-bottom: 0.25rem;
        }

        .duration {
          color: $text-gray;
          font-size: 0.9rem;
        }
      }
    }

    .modal-close {
      background: none;
      border: none;
      font-size: 1.5rem;
      cursor: pointer;
      color: $text-gray;
      transition: color 0.3s ease;

      &:hover {
        color: $soft-black;
      }
    }

    .preview-video-task-description {
      font-size: 0.9rem;
      color: $text-gray;
    }

    video {
      width: 100%;
      height: 423px;
      background-color: black;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      margin-bottom: 1rem;
    }
  }
  .task-actions {
    display: grid;
    grid-template-columns: auto auto;
    gap: 1rem;
    justify-content: center;
    background-color: $secondary-background-color;
    padding: 1rem;
    border-radius: 0rem 0rem 0.5rem 0.5rem;
  }
</style>

<script>
  import ActionButton from "./Components/ActionButton.svelte";
  import Modal from "./Components/Modal.svelte";
  import {
    createVideoTracker,
    interactiveTasks,
    isVideoPlaying,
    showVideoPreviewModal,
  } from "./stores";

  const closeModal = () => {
    isVideoPlaying.set(false);
    $showVideoPreviewModal = false;
  };

  $: task = $interactiveTasks.tasks.find(
    (t) => t.taskId === $interactiveTasks.selectedTaskId
  );

  $: src = [
    window.location.host === "localhost" ? "https://sourcewhale.app" : "",
    task?.videoPreview,
  ].join("");
  $: disabled = task?.cta.primary.attributes.disabled ? "locked" : "";

  // Sensible autoplay policy.
  let autoPlayed = false;
  $: if (!$showVideoPreviewModal) {
    autoPlayed = false;
  }

  let videoEl;
  let videoTracker = {};

  $: if (videoEl && task && videoTracker.taskId !== task.taskId) {
    if (videoTracker.reset) videoTracker.reset();
    videoTracker = createVideoTracker({
      videoEl,
      isPreview: true,
    });
  }

  const canPlay = () => {
    if (videoEl && !autoPlayed) {
      autoPlayed = true;
      videoEl.play();
      isVideoPlaying.set(true);
    }
  };

  const handleButtonClick = () => videoEl && videoEl.pause();
</script>

{#if task?.videoPreview && $showVideoPreviewModal}
  <Modal showModal={$showVideoPreviewModal}>
    <div class="video-preview-content">
      <div class="video-modal-header">
        <div class="title-and-duration">
          <h2>{task.title}</h2>
          <span class="duration">About {task.duration} mins</span>
        </div>
        <button
          class="modal-close"
          on:click={closeModal}
          aria-label="Close modal"
        >
          <i class="fa-solid fa-times"></i>
        </button>
      </div>
      <p class="preview-video-task-description">{task.description}</p>
      <!-- svelte-ignore a11y-media-has-caption -->
      <video bind:this={videoEl} {src} controls on:canplay={canPlay}> </video>
    </div>
    <div class="task-actions">
      <ActionButton
        class="primary"
        {...task.cta.primary.attributes}
        {disabled}
        onclick={handleButtonClick}
      >
        {task.cta.primary.text}
      </ActionButton>
      <ActionButton
        class="secondary"
        {...task.cta.secondary.attributes}
        onclick={handleButtonClick}
      >
        {task.cta.secondary.text}
      </ActionButton>
    </div>
  </Modal>
{/if}
